/* Sprint 20 — Vehicle catalog data + recency store for fast phone-booking entry.
   Kept as a single file (no standalone module) to avoid inflating structure. */

export const BRANDS = [
  "Volkswagen", "Mercedes-Benz", "BMW", "Audi", "Opel", "Ford", "Skoda",
  "Renault", "Peugeot", "Citroen", "Toyota", "Hyundai", "Kia", "Nissan",
  "Mazda", "Fiat", "SEAT", "CUPRA", "Volvo", "Porsche", "Tesla", "Dacia",
  "Smart", "Honda", "Mitsubishi", "Land Rover", "Jaguar", "Alfa Romeo",
  "Suzuki", "Mini",
];

// Common models per brand (not exhaustive — user may enter custom).
export const MODELS_BY_BRAND = {
  "Volkswagen": ["Golf", "Polo", "Passat", "Tiguan", "Touran", "T-Roc", "T-Cross", "Touareg", "Caddy", "Multivan", "ID.3", "ID.4"],
  "Mercedes-Benz": ["A-Klasse", "B-Klasse", "C-Klasse", "E-Klasse", "S-Klasse", "CLA", "CLS", "GLA", "GLB", "GLC", "GLE", "GLS", "V-Klasse", "Sprinter"],
  "BMW": ["1er", "2er", "3er", "4er", "5er", "7er", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "i3", "i4", "i5", "iX"],
  "Audi": ["A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q4 e-tron", "Q5", "Q7", "Q8", "TT"],
  "Opel": ["Corsa", "Astra", "Insignia", "Mokka", "Crossland", "Grandland", "Zafira", "Combo", "Vivaro"],
  "Ford": ["Fiesta", "Focus", "Mondeo", "Kuga", "Puma", "Ecosport", "Explorer", "Mustang", "Transit", "Tourneo"],
  "Skoda": ["Fabia", "Scala", "Octavia", "Superb", "Kamiq", "Karoq", "Kodiaq", "Enyaq"],
  "Renault": ["Clio", "Captur", "Megane", "Scenic", "Austral", "Arkana", "Kadjar", "Koleos", "Kangoo", "Trafic", "Twingo", "Zoe"],
  "Peugeot": ["108", "208", "308", "508", "2008", "3008", "5008", "Rifter", "Partner"],
  "Citroen": ["C1", "C3", "C4", "C5 Aircross", "Berlingo", "Jumpy", "e-C4"],
  "Toyota": ["Aygo", "Yaris", "Corolla", "Camry", "C-HR", "RAV4", "Highlander", "Prius", "Hilux", "Land Cruiser", "Proace"],
  "Hyundai": ["i10", "i20", "i30", "Kona", "Bayon", "Tucson", "Santa Fe", "Ioniq 5", "Ioniq 6"],
  "Kia": ["Picanto", "Rio", "Ceed", "XCeed", "Stonic", "Sportage", "Sorento", "Niro", "EV6"],
  "Nissan": ["Micra", "Juke", "Qashqai", "X-Trail", "Leaf", "Ariya", "Navara"],
  "Mazda": ["2", "3", "6", "CX-3", "CX-30", "CX-5", "CX-60", "MX-5", "MX-30"],
  "Fiat": ["500", "500X", "Panda", "Tipo", "Doblo", "Ducato", "600"],
  "SEAT": ["Ibiza", "Leon", "Arona", "Ateca", "Tarraco", "Alhambra"],
  "CUPRA": ["Leon", "Formentor", "Born", "Ateca", "Tavascan"],
  "Volvo": ["XC40", "XC60", "XC90", "S60", "S90", "V60", "V90", "EX30", "EX90"],
  "Porsche": ["911", "Cayenne", "Macan", "Panamera", "Taycan", "718 Cayman", "718 Boxster"],
  "Tesla": ["Model 3", "Model Y", "Model S", "Model X", "Cybertruck"],
  "Dacia": ["Sandero", "Logan", "Duster", "Jogger", "Spring", "Bigster"],
  "Smart": ["ForTwo", "ForFour", "#1", "#3"],
  "Honda": ["Jazz", "Civic", "HR-V", "CR-V", "e:Ny1", "ZR-V"],
  "Mitsubishi": ["Space Star", "ASX", "Eclipse Cross", "Outlander", "L200"],
  "Land Rover": ["Defender", "Discovery", "Discovery Sport", "Range Rover", "Range Rover Sport", "Range Rover Evoque", "Range Rover Velar"],
  "Jaguar": ["XE", "XF", "F-Pace", "E-Pace", "I-Pace", "F-Type"],
  "Alfa Romeo": ["Giulia", "Stelvio", "Tonale", "Giulietta"],
  "Suzuki": ["Swift", "Ignis", "Vitara", "S-Cross", "Jimny", "Across"],
  "Mini": ["Cooper", "Cooper S", "Countryman", "Clubman", "Electric"],
};

export const COLORS = [
  "Schwarz", "Weiß", "Silber", "Grau", "Anthrazit", "Blau", "Rot", "Grün",
  "Braun", "Beige", "Gelb", "Orange", "Violett", "Gold", "Sonstige",
];

// Sprint 21 — canonical name ↔ hex mapping for the swatch dot.
export const COLOR_NAME_TO_HEX = {
  "schwarz":   "#111827",
  "weiß":      "#F8FAFC",
  "weiss":     "#F8FAFC",
  "silber":    "#CBD5E1",
  "grau":      "#6B7280",
  "anthrazit": "#374151",
  "blau":      "#2563EB",
  "rot":       "#DC2626",
  "grün":      "#16A34A",
  "gruen":     "#16A34A",
  "braun":     "#78350F",
  "beige":     "#E7DAB4",
  "gelb":      "#EAB308",
  "orange":    "#F97316",
  "violett":   "#7C3AED",
  "gold":      "#D4AF37",
  "sonstige":  "#9CA3AF",
};

// Reverse lookup — hex (uppercase) → canonical German name.
// Includes both the canonical Sprint 20 palette and the legacy Service-catalog
// palette so that vehicles with HEX values still show a human name.
export const COLOR_HEX_TO_NAME = {
  ...Object.entries(COLOR_NAME_TO_HEX)
    .filter(([n]) => !["weiss", "gruen"].includes(n))
    .reduce((acc, [n, h]) => { acc[h.toUpperCase()] = n.charAt(0).toUpperCase() + n.slice(1); return acc; }, {}),
  // Legacy service palette (see ServicesPage.jsx COLORS)
  "#10B981": "Grün",
  "#14B8A6": "Grün",
  "#16A34A": "Grün",
  "#F59E0B": "Gelb",
  "#8B5CF6": "Violett",
  "#3B82F6": "Blau",
  "#06B6D4": "Blau",
  "#3377FF": "Blau",
  "#EF4444": "Rot",
  "#F97316": "Orange",
  "#64748B": "Grau",
  "#EC4899": "Sonstige",
};

const HEX_RE = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

/** True if the value looks like a HEX color code. */
export function isHexColor(v) {
  return typeof v === "string" && HEX_RE.test(v.trim());
}

/** Normalizes 3-digit HEX to 6-digit uppercase. */
function normalizeHex(h) {
  const s = h.trim().toUpperCase();
  if (s.length === 4) return "#" + s.slice(1).split("").map((c) => c + c).join("");
  return s;
}

/** Returns the human-readable color name. If input is HEX, tries to reverse-map;
 *  otherwise returns the input as-is (or "" when empty). */
export function colorDisplayName(value) {
  const v = (value || "").trim();
  if (!v) return "";
  if (isHexColor(v)) {
    const h = normalizeHex(v);
    return COLOR_HEX_TO_NAME[h] || "Farbe";
  }
  return v;
}

/** Returns the HEX to use for the visual swatch dot. */
export function colorSwatchHex(value) {
  const v = (value || "").trim();
  if (!v) return "";
  if (isHexColor(v)) return normalizeHex(v);
  const key = v.toLowerCase();
  return COLOR_NAME_TO_HEX[key] || "#9CA3AF";
}

// ─── Recency store (localStorage, LRU + frequency) ────────────────────
const KEY = (kind) => `stellar_recent_${kind}`;
const CAP = 30;

function loadRaw(kind) {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY(kind)) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch { return []; }
}

/** Returns array of {value, count, ts} sorted most-recent + frequent first. */
export function loadRecent(kind) {
  return loadRaw(kind);
}

/** Bump usage of a value (adds if missing, moves to front, +1 count). */
export function bumpRecent(kind, value) {
  const v = (value || "").trim();
  if (!v) return;
  const list = loadRaw(kind);
  const now = Date.now();
  const idx = list.findIndex((x) => x.value.toLowerCase() === v.toLowerCase());
  if (idx >= 0) {
    const [item] = list.splice(idx, 1);
    list.unshift({ value: v, count: (item.count || 1) + 1, ts: now });
  } else {
    list.unshift({ value: v, count: 1, ts: now });
  }
  try { localStorage.setItem(KEY(kind), JSON.stringify(list.slice(0, CAP))); } catch { /* ignore */ }
}

/** Returns predefined + custom values, with recent ones first. */
export function mergedOptions(predefined, kind) {
  const recent = loadRaw(kind);
  const seen = new Set();
  const out = [];
  for (const r of recent) {
    const key = r.value.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ value: r.value, recent: true });
  }
  for (const p of predefined) {
    const key = p.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ value: p, recent: false });
  }
  return out;
}

/** Tries to split "Brand Model rest…" into {brand, model} using known brand list.
 *  If no match, returns {brand: "", model: raw}. */
export function splitCarModel(raw) {
  const s = (raw || "").trim();
  if (!s) return { brand: "", model: "" };
  // Longest-match first so "Mercedes-Benz" wins over "Mercedes".
  const sorted = [...BRANDS].sort((a, b) => b.length - a.length);
  const lower = s.toLowerCase();
  for (const b of sorted) {
    const bl = b.toLowerCase();
    if (lower === bl) return { brand: b, model: "" };
    if (lower.startsWith(bl + " ") || lower.startsWith(bl + "-")) {
      return { brand: b, model: s.slice(b.length).replace(/^[-\s]+/, "") };
    }
  }
  return { brand: "", model: s };
}

/** Joins brand + model into single legacy car_model field. */
export function joinCarModel(brand, model) {
  return [`${(brand || "").trim()}`, `${(model || "").trim()}`].filter(Boolean).join(" ").trim();
}
